import React, { useEffect, useRef } from "react";
import CreditCard from "./CreditCard";
import "./payment.css";
import { toast } from "react-hot-toast";

const PayForm = ({
  payFormFullname,
  setPayFormFullname,
  cardNumber,
  setCardNumber,
  expiryDate,
  setExpiryDate,
  cvvNumber,
  setCvvNumber,
  focused,
  setFocused,
  handleConfirmPaymentForm,
  isConfirmed,
  isConfirmedPaymentForm,
  handleEditPayform,
  expiryDateCheck,
  setExpiryDateCheck,
}) => {
  const cvvNumberFocusRef = useRef();
  const expiryNumberFocusRef = useRef();
  const fullnameRef = useRef();

  //! Address If the form is filled -
  //! focus on the fullname input.
  useEffect(() => {
    if (isConfirmed && !isConfirmedPaymentForm) {
      fullnameRef.current.focus();
    }
  }, [isConfirmed]);

  //! If Expiry Date is Valid, Focus on Cvv Input
  useEffect(() => {
    if (expiryDateCheck) {
      cvvNumberFocusRef.current.focus();
    }
  }, [expiryDateCheck]);

  //! onfocus
  const handleFocus = () => {
    setFocused(true);
  };
  //! onblur
  const handleBlur = () => {
    setFocused(false);
  };

  //! Ensuring that only strings are entered into the input
  const handleFullnameChangeString = (event) => {
    const { value } = event.target;
    // Gelen değer içinde sadece harf karakterleri olup olmadığını kontrol ediyoruz
    const onlyLetters = /^[A-Za-zğüşıöçĞÜŞİÖÇ\s]+$/;
    if (value === "" || onlyLetters.test(value)) {
      setPayFormFullname(value);
    }
  };

  //! Ensuring that only numbers are entered into the input
  const handleChangeCardNumber = (event) => {
    const inputVal = event.target.value.replace(/\D/g, "");
    // Yukarıdaki kod, sadece sayısal karakterleri korur ve diğer karakterleri kaldırır.

    let spacedVal = "";
    for (let i = 0; i < inputVal.length; i++) {
      if (i > 0 && i % 4 === 0) {
        spacedVal += " ";
      }
      spacedVal += inputVal[i];
    }
    setCardNumber(spacedVal);

    if (spacedVal.length === 19) {
      expiryNumberFocusRef.current.focus();
    }
  };

  //! Necessary edit for expiry date input
  const handleChangeExpiryDate = (event) => {
    const today = new Date();
    const nowMonth = today.getMonth() + 1;
    const nowYear = today.getFullYear().toString().slice(-2);

    let inputVal = event.target.value.replace(/\D/g, "");
    let spacedVal = "";

    const inputMonth = inputVal.slice(0, 2);
    const inputYear = inputVal.slice(-2);

    if (inputVal.length > 1) {
      //! Ay kontrol
      const month = inputMonth;
      if (month > 12) {
        inputVal = "12" + inputVal.slice(2);
      }
    }

    if (inputVal.length > 3) {
      //! Yıl kontrol
      const year = inputYear;
      if (year < nowYear) {
        inputVal = inputVal.slice(0, 2) + nowYear;
      } else if (year > 40) {
        inputVal = inputVal.slice(0, 2) + "40";
      }

      if (
        (year === nowYear && inputMonth < nowMonth) ||
        (year <= nowYear && inputMonth <= nowMonth)
      ) {
        setExpiryDateCheck(false);
        toast("Invalid Card: Card Expired..", {
          style: {
            background: "#711b1b",
            color: "#fff",
            fontSize: ".75rem",
            textTransform: "uppercase",
          },
        });
      } else {
        setExpiryDateCheck(true);
      }
    }

    for (let i = 0; i < inputVal.length; i++) {
      if (i === 2) {
        spacedVal += "/";
      }
      spacedVal += inputVal[i];
    }

    setExpiryDate(spacedVal);
  };

  //! Necessary edit for cvv input
  const handleChangeCvvNumber = (event) => {
    const inputVal = event.target.value.replace(/\D/g, "").slice(0, 3);
    // Yukarıdaki kod, sadece sayısal karakterleri korur ve diğer karakterleri kaldırır.
    // Ardından, yalnızca ilk 3 karakteri alır.

    setCvvNumber(inputVal);
  };

  return (
    <div className="payform">
      {isConfirmedPaymentForm && (
        <div className="isConfirmPayform animate__animated animate__fadeIn">
          <div className="isConfirm-icon">
            <i className="fas fa-solid fa-circle-check"></i>
          </div>
        </div>
      )}
      <form className="form">
        <div className="payment--options">
          <CreditCard
            focused={focused}
            payFormFullname={payFormFullname}
            cardNumber={cardNumber}
            expiryDate={expiryDate}
            cvvNumber={cvvNumber}
          />
        </div>
        <div className="credit-card-info--form">
          <div className="input_container">
            <label className="input_label">Card holder full name</label>
            <input
              className="input_field text-capitalize"
              type="text"
              placeholder="ENTER YOUR FULL NAME"
              value={payFormFullname}
              id="payFormFullname"
              onChange={handleFullnameChangeString}
              ref={fullnameRef}
            />
          </div>
          <div className="input_container">
            <label className="input_label">Card Number</label>
            <input
              className="input_field"
              type="text"
              placeholder="1234 5678 9012 3456"
              value={cardNumber}
              maxLength={19}
              onChange={handleChangeCardNumber}
            />
          </div>
          <div className="input_container">
            <label className="input_label">Expiry Date / CVV</label>
            <div className="split">
              <input
                className="input_field"
                type="text"
                placeholder="01/26"
                value={expiryDate}
                onChange={handleChangeExpiryDate}
                maxLength={5}
                ref={expiryNumberFocusRef}
              />
              <input
                className="input_field"
                type="number"
                placeholder="CVV"
                value={cvvNumber.slice(0, 3)}
                maxLength={3}
                onChange={handleChangeCvvNumber}
                onFocus={handleFocus}
                onBlur={handleBlur}
                ref={cvvNumberFocusRef}
              />
            </div>
          </div>
        </div>
        {isConfirmedPaymentForm ? (
          <button onClick={handleEditPayform} className="purchase--btn">
            EDIT
          </button>
        ) : (
          <button onClick={handleConfirmPaymentForm} className="purchase--btn">
            CONFIRM
          </button>
        )}
      </form>
    </div>
  );
};

export default PayForm;
